<template>
	<PageLoading :is-loading="isLoading"></PageLoading>
	<SideComponent @scrollto="scroll"></SideComponent>
	<div class="container" ref="viewBox">
		<!-- 以下代码与index-pic是一套 -->
		<!-- <div class="header-container">
			<Header2 />			
		</div> -->
		
		<div class="content">
			<div class="index-pic">		
				<Swiper :list="banners"/>	
				<div class="pic-wrapper">
					
					<search-bar-pic :isNeedRedirect="false" @searchKeywords="searchNews"></search-bar-pic>
				</div>
			</div>
			<div class="news-container">
				<section id="news-wrapper" class="news-wrapper">
					<div class="news-left">
						<button
							type="button"
							class="text-style"
							:class="{ 'is-active': newsType === 1 }"
							@click="switchType(1)"
						>{{$t('news.news')}}</button>
						<button
							type="button"
							class="text-style"
							:class="{ 'is-active': newsType === 2 }"
							@click="switchType(2)"
						>{{$t('news.visual')}}</button>
					</div>
					<div class="news-right" id="newslist" v-show="newsType === 1">
						<div class="news-item" v-for="item in newsList" :key="item.id" @click="toDetail(item.id)">  
							<div class="news-item-outer">
								<div class="img-outer">
									<img :src="item.thumb" oncontextmenu="return false" :alt="item.title"/>
								</div>
								<div class="news-title">
									<span v-html="item.title"></span>
								</div>
							</div>
						</div>	
					</div>
					<div class="news-right" v-show="newsType === 2">
						<div class="enclosure">
							<section class="section masonry">
								<div class="masonry-column" v-for="(column, colIndex) in videoColumns" :key="colIndex">
									<div class="_1Aw4E" v-for="item in column" :key="item.id">
										<div @click="toVisualDetail(item.id)" style="width:100%;">
											<video v-if="isMobile"
												:poster="item.thumb"
												preload="none"
												muted=""
												:alt="item.title"
												:style="getVideoAspectStyle(item)"
												controlslist="nodownload"
												oncontextmenu="return false">
												<track kind="captions" />
												<source :src="item.video" type="video/mp4">
											</video>
											<video v-else
												controls
												:poster="item.thumb"
												preload="none"
												muted=""
												:alt="item.title"
												:style="getVideoAspectStyle(item)"
												controlslist="nodownload"
												oncontextmenu="return false"
												:src="item.video">
												<track kind="captions" />
											</video>
										</div>
										<div class="video_name">
											<span v-html="item.title"></span>
										</div>
									</div>
								</div>
							</section>
						</div>
					</div>
					
					<!-- <div class="page-wrapper">
						<el-pagination 
						    background 
						    layout="prev, pager, next" 
						    :total="pagination.total" 
						    v-model:current-page="pagination.current"
						    v-model:page-size="pagination.pageSize"	    
						/>
					</div> -->
				</section>
				<div class="loadmore">
					<Loading :is-loading="isPicLoading"></Loading>
					<span class="more" @click="loadMore()" v-if="!nomore">{{$t('loadmore')}}</span>
					<span class="end" v-if="nomore">- {{$t('theEnd')}} -</span>
				</div>
			</div>

		</div>
		<Footer/>
	</div>
</template>

<script>
	import news from './news_controller';
	export default news;
</script>

<style src="@/assets/css/news.css" scoped></style>